import React from 'react';
import { Layout } from '../components/Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { FileText, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

export const RelatoriosPage = () => {
  return (
    <Layout>
      <div className="space-y-6" data-testid="relatorios-page">
        <div>
          <h1 className="text-4xl font-black tracking-tight">Relatórios</h1>
          <p className="text-muted-foreground mt-2">
            Exporte dados e gere relatórios personalizados
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5 text-primary" />
                Relatório de Lideranças
              </CardTitle>
              <CardDescription>
                Exportar lista completa de lideranças com estatísticas
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" data-testid="export-liderancas-btn">
                <Download className="h-4 w-4 mr-2" />
                Exportar CSV
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5 text-primary" />
                Relatório de Acessos
              </CardTitle>
              <CardDescription>
                Exportar histórico de acessos e redirecionamentos
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" data-testid="export-acessos-btn">
                <Download className="h-4 w-4 mr-2" />
                Exportar CSV
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5 text-primary" />
                Relatório de Links
              </CardTitle>
              <CardDescription>
                Exportar lista de links com estatísticas de desempenho
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" data-testid="export-links-btn">
                <Download className="h-4 w-4 mr-2" />
                Exportar CSV
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5 text-primary" />
                Relatório de Apoiadores
              </CardTitle>
              <CardDescription>
                Exportar lista de apoiadores identificados
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" data-testid="export-apoiadores-btn">
                <Download className="h-4 w-4 mr-2" />
                Exportar CSV
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5 text-primary" />
                Ranking Completo
              </CardTitle>
              <CardDescription>
                Exportar ranking de lideranças com métricas
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" data-testid="export-ranking-btn">
                <Download className="h-4 w-4 mr-2" />
                Exportar CSV
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5 text-primary" />
                Relatório de Cartões
              </CardTitle>
              <CardDescription>
                Exportar lista de cartões NFC/QR com uso
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" data-testid="export-cartoes-btn">
                <Download className="h-4 w-4 mr-2" />
                Exportar CSV
              </Button>
            </CardContent>
          </Card>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Nota sobre Privacidade</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Os relatórios exportados contêm apenas dados essenciais para gestão da campanha.
              Registros anônimos não incluem informações pessoais identificáveis.
              Mantenha os arquivos exportados em local seguro.
            </p>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};
